export default __webpack_public_path__ + "static/media/tluszcze-icon.422be56c.svg";